import { SharedModule } from './shared/shared-module.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MaterialModule } from './material/material.module';
import { DialogAlertaComponent } from './cotizador-module/dialog-alerta/dialog-alerta.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IconsModule } from './icons/icons.module';
import { ThemeService } from './service/theme-service.service';
import { HttpClientModule } from '@angular/common/http';
import { CotizadorModuleModule } from './cotizador-module/cotizador/cotizador-module.module';
import { DescargaPolizaModule } from './pages/descarga-poliza/descarga-poliza.module';




@NgModule({
  declarations: [
    AppComponent,
    DialogAlertaComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MaterialModule,
    RouterModule,
    IconsModule,
    HttpClientModule,
    CotizadorModuleModule,
    DescargaPolizaModule,
    SharedModule,
    FormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    ReactiveFormsModule,
    FontAwesomeModule,
    CommonModule,
  ],
  providers: [
    provideAnimationsAsync(),
    ThemeService,
    provideNgxMask(),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
